import { Box, styled } from "@mui/material";

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flex: 1,
  backgroundColor: theme.palette.common.white,
}));

export default Container;
